import React from 'react'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import capitalizeFirstWord from 'services/helper/capitalizeFirstWord'

const Column1 = ({ muiIcon, reportName, reportType, startDate, endDate }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          bgcolor: 'alternate.light',
          borderRadius: '50%',
          aspectRatio: 1,
          width: 50,
          height: 50,
        }}
      >
        <Icon sx={{ fontSize: 25, color: 'alternate.main' }}>{muiIcon}</Icon>
      </Box>
      <Box>
        <Typography
          variant="body1"
          color="dark-text.main"
          sx={{ whiteSpace: 'wrap', textOverflow: 'ellipsis' }}
        >
          {capitalizeFirstWord(reportName)}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            noWrap
            component="span"
            variant="body2"
            color="light-gray-text.main"
            textTransform="capitalize"
          >
            {reportType}
          </Typography>
          <Icon sx={{ fontSize: 7, color: 'light-gray-text.main' }}>circle_rounded</Icon>
          <Typography
            noWrap
            component="span"
            variant="body2"
            color="light-gray-text.main"
            textTransform="capitalize"
          >
            {startDate} - {endDate}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default Column1
